<div class="apg-loading" *ngIf="loading">
  <p>{{message}}</p>
  <ion-spinner></ion-spinner>
</div>

<app-site-content *ngIf="error" [key]="error">
</app-site-content>

<ng-container [ngSwitch]="page" *ngIf="!loading && !error">

  <app-verify-quote [key]="key" (loaded)="quoteLoaded($event)" *ngSwitchCase="'load'" (back)="prevPage()">
  </app-verify-quote>

  <app-quick-quote-summary *ngSwitchCase="'summary-1'" [quickQuote]="quickQuote" [quote]="quote" [page]="page"
                           (back)="prevPage()" (continue)="nextPage()">
  </app-quick-quote-summary>

  <app-capture-address *ngSwitchCase="'address'" [quickQuote]="quickQuote" [quote]="quote" [key]="key"
                       (back)="prevPage()" (continue)="nextPage()">
  </app-capture-address>

  <app-quick-quote-summary *ngSwitchCase="'summary-2'" [quote]="quote" [quickQuote]="quickQuote" [page]="page"
                           (back)="prevPage()" (continue)="nextPage()">
  </app-quick-quote-summary>

  <app-declaration *ngSwitchCase="'declaration'" [quickQuote]="quickQuote" (back)="prevPage()" (continue)="nextPage()">
  </app-declaration>

  <app-magnum-questions *ngSwitchCase="'questions'" [quote]="quote" (complete)="questionsComplete($event)">
  </app-magnum-questions>

  <app-quote-result *ngSwitchCase="'result'" [result]="magnumResult" [quickQuote]="quickQuote" [quote]="quote"
                    (back)="prevPage()" (newQuote)="newQuote.emit()" [key]="key" (continue)="nextPage()">
  </app-quote-result>

  <app-final-declaration *ngSwitchCase="'final-declaration'" (back)="prevPage()" (continue)="nextPage()">
  </app-final-declaration>

  <app-bank-details *ngSwitchCase="'bank-details'" [key]="key" [premium]="quickQuote.answersObject['MagnumPremium']"
                    (back)="prevPage()" (continue)="bindPolicy()">
  </app-bank-details>

  <app-complete-quote *ngSwitchCase="'complete'">
  </app-complete-quote>
</ng-container>